import { render, staticRenderFns } from "./Requisition.vue?vue&type=template&id=612b2c74&scoped=true"
import script from "./Requisition.vue?vue&type=script&lang=js"
export * from "./Requisition.vue?vue&type=script&lang=js"
import style0 from "./Requisition.vue?vue&type=style&index=0&id=612b2c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b2c74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VAvatar,VBreadcrumbs,VChip,VContainer,VSpacer})
